import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Spinner from 'components/Spinner';
import RadioButton from 'components/RadioButton';
import PlanDetails from 'components/widget/PlanDetails';

const Wrapper = styled.div`
  min-height: 8rem;
  position: relative;
  background-color: white;
  > ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li:nth-child(n + 2) {
      border-top: 1px solid ${({ theme }) => theme.palette.grey[4]};
    }
    label {
      padding: ${({ theme }) => theme.spacing * 3}px
        ${({ theme }) => theme.spacing * 2}px;
    }
  }

  .radioUi {
    margin-top: 3px;
  }
`;

const LensPlanOptions = ({
  className, plans, onChange, dataLayerAction,
}) => {
  const classes = ['LensPlanOptions'];
  if (className) classes.push(className);

  function manageChange(e) {
    onChange(e.target.value);
  }

  return (
    <Wrapper className={classes.join(' ')}>

      {(!plans || !plans.length) && <Spinner relativeToParent />}
      <ul>
        {plans && plans.map((p) => {
          const { id, selected, ...rest } = p;
          return (
            <li key={id}>
              <RadioButton
                onChange={manageChange}
                name="planOption"
                value={id}
                checked={selected}
                disabled={selected}
                dataLayer={{ action: dataLayerAction, label: `Select amount - ${p.title}` }}
              >
                <PlanDetails {...rest} />
              </RadioButton>
            </li>
          );
        })}
      </ul>
    </Wrapper>
  );
};

LensPlanOptions.displayName = 'LensPlanOptions';

LensPlanOptions.propTypes = {
  className: PropTypes.string,
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  dataLayerAction: PropTypes.string.isRequired,
};

LensPlanOptions.defaultProps = {
  className: null,
};

export default LensPlanOptions;
